import React, { MouseEvent } from 'react'
import { Typography } from 'antd'
import { HeartOutlined, HeartFilled } from '@ant-design/icons'

export default function FavoritesButton({
	isFavorite,
	onClick,
}: {
	isFavorite: boolean
	onClick: (e: MouseEvent<any>) => void
}) {
	const iconStyle = { fontSize: 20 }

	return (
		<Typography.Link onClick={onClick} style={{ display: 'flex', alignItems: 'center' }}>
			{isFavorite ? <HeartFilled style={iconStyle} /> : <HeartOutlined style={iconStyle} />}
			<b style={{ paddingLeft: 6 }}>{isFavorite ? 'In' : 'Add To'} Favorites</b>
		</Typography.Link>
	)
}
